/* eslint-disable class-methods-use-this */
import axios from "axios";

import {API_SUPPLIER_URL, COMMON_HEADER_CONFIG} from "../config";

class SupplierService {
  getAccessToken = () => localStorage.getItem("accessToken");

  getListSupplier = (params = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_SUPPLIER_URL}/suppliers`,
        params: {
          size: 100,
          page: 1,
          ...params
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createOneSupplier = (data) =>
    new Promise((resolve, reject) => {
      // const dataCreate = JSON.stringify(data);
      const config = {
        method: "post",
        url: `${API_SUPPLIER_URL}/supplier`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data
      };

      axios(config)
        .then((response) => {
          if (
            response.data &&
            (response.data.code === 1 || response.data.code === "success")
          ) {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getOneSupplier = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_SUPPLIER_URL}/supplier/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (
            response.data &&
            (response.data.code === 1 || response.data.code === "success")
          ) {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateSupplier = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "patch",
        url: `${API_SUPPLIER_URL}/supplier/${data.id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };

      axios(config)
        .then((response) => {
          if (
            response.data &&
            (response.data.code === 1 || response.data.code === "success")
          ) {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  deleteOneSupplier = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "delete",
        url: `${API_SUPPLIER_URL}/supplier/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        }
      };

      axios(config)
        .then((response) => {
          if (
            response.data &&
            (response.data.code === 1 || response.data.code === "success")
          ) {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  deleteBulkSupplier = (listSupplier) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "post",
        url: `${API_SUPPLIER_URL}/suppliers`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data: listSupplier
      };

      axios(config)
        .then((response) => {
          if (
            response.data &&
            (response.data.code === 1 || response.data.code === "success")
          ) {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const supplierService = new SupplierService();

export default supplierService;
